module.exports = __webpack_public_path__ + "img/prod_cat_slot.3b4d5672.png";